import { T安全管理実施 } from "../../../service/driver/anzenKanri/TAnzenKanri"
import { T健康診断実施 } from "../../../service/driver/kenkoSindan/TKenkoSindan"
import { T適性診断実施一覧 } from "../../../service/driver/tekiseiSindan/TTekiseiSindan"

/**
 * 健康診断記録
 */
export type TKenkoSindanKirokuDataTable = {
  健康診断記録データリスト: TKenkoSindanKirokuData[]
}

export type TKenkoSindanKirokuData = T健康診断実施 & {
  row_id?: string
}

/**
 * 安全会議記録
 */
export type TAnzenKaigiKirokuDataTable = {
  安全会議記録データリスト: TAnzenKaigiKirokuData[]
}

export type TAnzenKaigiKirokuData = T安全管理実施 & {
  row_id?: string
}
/**
 * 適性診断記録
 */
export type TTekiseiSindanKirokuDataTable = {
  適正診断記録データリスト: TTekiseiSindanKirokuData[]
}

export type TTekiseiSindanKirokuData = T適性診断実施一覧 & {
  row_id?: string
}

//#region 初期値

export const initialKenkoSindanKirokuDataTable: TKenkoSindanKirokuDataTable = {
  健康診断記録データリスト: [],
}

export const initialAnzenKaigiKirokuDataTable: TAnzenKaigiKirokuDataTable = {
  安全会議記録データリスト: [],
}

export const initialTekiseiSindanKirokuDataTable: TTekiseiSindanKirokuDataTable =
  {
    適正診断記録データリスト: [],
  }

//#endregion
